var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import moment from 'moment';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Entity } from '@debbie/common/dist';
import { CaseVoucherSource } from '@debbie/common/dist/economy/case-vouchers';
import { VoucherTypeIds } from '@debbie/common/dist/economy/vouchers';
import Button from '../../Button';
import Checkbox from '../../Checkbox';
import DateInput from '../../DateInput';
import MoneyInput from '../../MoneyInput';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors';
import NewEntityProperties from '../../Properties/NewEntityProperties';
const CourtCostVoucherCreator = (props) => {
    var _a;
    const lang = useSelector((s) => s.lang);
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    const defaultAmounts = {
        [VoucherTypeIds.BAILIFFSFEE]: 75000,
        [VoucherTypeIds.FOGEDREKVISITIONSFEE]: 75000,
    };
    const defaultAmount = defaultAmounts[props.voucherTypeId] || NaN;
    const [loading, setLoading] = useState(false);
    const [amount, setAmount] = useState(defaultAmount);
    const [date, setDate] = useState(new Date());
    const [imposedByCreditor, setImposedByCreditor] = useState(false);
    const [properties, setProperties] = useState(null);
    const canSubmit = Number.isInteger(amount);
    const createVoucher = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!canSubmit) {
            return;
        }
        setLoading(true);
        yield props.onCreate({
            voucherTypeId: props.voucherTypeId,
            amount: -amount,
            date: date.toISOString(),
            source: imposedByCreditor
                ? CaseVoucherSource.Creditor
                : CaseVoucherSource.Collector,
            properties: properties || undefined,
        });
        setLoading(false);
    });
    return (React.createElement(Wrapper, null,
        React.createElement(OneLine, null,
            React.createElement(DateWrapper, null,
                React.createElement(DateInput, { placeholder: lang.economy.date, allowNull: false, value: moment(date), onChange: (d) => setDate(d.toDate()) })),
            React.createElement(InputWrapper, null,
                React.createElement(MoneyInput, { value: amount, onChange: setAmount, placeholder: lang.economy.amount }))),
        React.createElement(Checkbox, { placeholder: lang.economy.imposedByCreditor, onChange: (e) => setImposedByCreditor(e.target.checked), checked: imposedByCreditor }),
        ((_a = singleCase === null || singleCase === void 0 ? void 0 : singleCase.caseGroup) === null || _a === void 0 ? void 0 : _a.id) && (React.createElement(NewEntityProperties, { propRef: Entity.CaseVoucher, scope: "case_groups", scopeId: singleCase.caseGroup.id, onChange: (p) => {
                let exists = false;
                setProperties(properties && properties.length > 0
                    ? properties
                        .map((prop) => {
                        if (prop.handle === p.handle) {
                            exists = true;
                            return p;
                        }
                        else {
                            return prop;
                        }
                    })
                        .concat(exists ? [] : [p])
                    : [p]);
            } })),
        React.createElement(Button, { disabled: !canSubmit, style: { width: '100%' }, loading: loading, onClick: createVoucher },
            lang.economy.voucherCreationCreate,
            ' ',
            lang.economyVoucherTypeLabels[props.voucherTypeId])));
};
export default CourtCostVoucherCreator;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
`;
const OneLine = styled.div `
  display: flex;
`;
const DateWrapper = styled.div `
  width: 100%;
  margin-right: 20px;
`;
const InputWrapper = styled.div `
  width: 100%;
`;
//# sourceMappingURL=CourtCostVoucherCreator.js.map